export const QUERY_KEYS = {
  WEEKLY_USER_STATS: 'weekly-user-stats',
  WEEK_REPORT_OPTIONS: 'report-week-options',
  BUSINESS_REPORT: 'business-report',
  REVENUE_DETAILS: 'revenue-details',
}
